import * as yup from "yup";

/**
 * Server-side filters for GET ops/disbursements/v1.
 *
 * `status` is one of fund_received / in_progress / settled — leaving it empty
 * returns all three. `debit_note_number` is a case-insensitive partial match.
 */
export const disbursementFiltersSchema = yup.object({
    debit_note_number: yup.string().trim().default(""),
    account_id       : yup.string().trim().default(""),
    status           : yup.string().trim().default("")
});

export const defaultDisbursementFilters = disbursementFiltersSchema.getDefault();

export const toDisbursementFilterParams = async (filters) => {
    const validated = await disbursementFiltersSchema.validate(filters, { stripUnknown: true });

    const params = {};
    if (validated.debit_note_number) params.debit_note_number = validated.debit_note_number;
    if (validated.account_id) params.account_id = validated.account_id;
    if (validated.status) params.status = validated.status;

    return params;
};
